import { NextArrow, PrevArrow } from '../Shared';
import { PhotoSwipe } from 'react-photoswipe';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Slider from "react-slick";

export default class Carousel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            index: 0,
            photo_carousel_open: false,
        };
        
        this.closePhotoCarousel = this.closePhotoCarousel.bind(this);
        this.getImages = this.getImages.bind(this);
        this.openPhotoCarousel = this.openPhotoCarousel.bind(this);
        this.showImage = this.showImage.bind(this);
    }
    
    closePhotoCarousel () 
    {
        this.setState({
            photo_carousel_open: false
        });
    };
    
    getImages()
    {
        let images = [];
        
        _.forEach(this.props.data.images, (image) => {
            
            images.push({
                src: image,
                w: 1600,
                h: 1000
            });
        });
        
        //console.log(images);
        
        return images;
    }
    
    openPhotoCarousel()
    {
        this.setState({
            photo_carousel_open: true
        });
    }
    
    showImage(index)
    {
        this.setState({
            index: index
        }, () => 
        {
            this.openPhotoCarousel();
        });
    }
        
    render() {
        
        const { images } = this.props.data;
        
        return (
            <div>
                {
                    !_.isEmpty(images) &&
                    images.length > 1 &&
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div id="mdb-lightbox-ui"></div>
                                    <Slider {...{
                                        className: "slick-carousel mdb-lightbox",
                                        infinite: true,
                                        initialSlide: 0,
                                        slidesToShow: images.length >= 3 ? 3 : 2,
                                        slidesToScroll: 1,
                                        prevArrow: <PrevArrow />,
                                        nextArrow: <NextArrow />,
                                        responsive: [
                                            {
                                                breakpoint: 1200,
                                                settings: {
                                                    slidesToShow: images.length >= 3 ? 3 : 2,
                                                    slidesToScroll: 1
                                                }
                                            },
                                            {
                                                breakpoint: 1024,
                                                settings: {
                                                    arrows: false,
                                                    centerMode: true,
                                                    centerPadding: '20px',
                                                    slidesToShow: 2,
                                                    slidesToScroll: 1
                                                }
                                            },
                                            {
                                                breakpoint: 768,
                                                settings: {
                                                    arrows: false,
                                                    centerMode: true,
                                                    centerPadding: '20px',
                                                    slidesToShow: 1,
                                                    slidesToScroll: 1
                                                }
                                            }
                                        ]
                                    }}>
                                        {
                                            images.map((image, key) => {

                                                return (
                                                    <figure 
                                                        key={key} 
                                                        className="view overlay hm-primary-strong cursor-pointer"
                                                        onClick={() => { this.showImage(key) }}
                                                    >
                                                        <a className="slick-view">
                                                            <img src={image} className="img-fluid" />
                                                        </a>
                                                        <div className="mask flex-center">
                                                            <p className="white-text">
                                                                <i className="fa fa-eye fa-lg"></i>
                                                            </p>
                                                        </div>
                                                    </figure>
                                                )
                                            })
                                        }
                                    </Slider>
                            </div>
                        </div>
                        
                        <PhotoSwipe 
                            isOpen={this.state.photo_carousel_open} 
                            items={this.getImages()} 
                            onClose={this.closePhotoCarousel}
                            options={{index: this.state.index, history: false, closeOnScroll: false, shareEl: false, zoomEl: false}}
                        />
                    </div>
                }
            </div>
        );
    }
}

if (document.getElementById('carousel')) {
    
    const element = document.getElementById('carousel');
    const data = Object.assign({}, element.dataset);
        
    //console.log(data.data);
    
    ReactDOM.render(<Carousel data={JSON.parse(data.data)} />, document.getElementById('carousel'));
}



// WEBPACK FOOTER //
// ./resources/js/components/Shortcodes/Carousel.js